import React, { useState } from 'react';
import { useImageModal } from '../contexts/ImageModalContext';

const Gallery = ({ images, title, sectionId }) => {
  const [imageErrors, setImageErrors] = useState({});
  const { openModal } = useImageModal();

  const handleImageError = (index) => {
    setImageErrors(prev => ({ ...prev, [index]: true }));
  };

  const getImageSrc = (image, index) => {
    if (imageErrors[index]) {
      return `https://via.placeholder.com/600x400/333333/FFFFFF?text=${encodeURIComponent(image.alt)}`;
    }
    return image.src;
  };

  const handleImageClick = (index) => {
    // Generate unique section ID if not provided
    const uniqueSectionId = sectionId || `gallery-${title.toLowerCase().replace(/\s+/g, '-')}`;
    openModal(images, index, uniqueSectionId);
  };

  return (
    <section className="gallery-section">
      <div className="container">
        <h2 className="gallery-title">{title}</h2>
        <div className="gallery-grid">
          {images.map((image, index) => (
            <div 
              key={index} 
              className="gallery-item"
              onClick={() => handleImageClick(index)}
              style={{ cursor: 'pointer' }}
            >
              <img 
                src={getImageSrc(image, index)} 
                alt={image.alt}
                onError={() => handleImageError(index)}
                loading="lazy"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
              <div className="gallery-overlay">
                <p>{image.description}</p>
                <div className="gallery-click-hint">
                  Click to view full size
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
